export default class FizyLogo {
  public href = '/';
}



// WEBPACK FOOTER //
// src/app/components/fizy-logo/fizy-logo.controller.ts